







import { Component, Vue, Prop } from 'vue-property-decorator';
import { ValidatableInterface } from '@/types/Validatable';

@Component({})
export default class FormGroup extends Vue {
  @Prop() text?: string;

  validated = false;
  valid = false;

  async validate(silent = false) {
    this.validated = true;
    const validations = [];

    for (const slot of this.$children as any) {
      if (typeof slot.validate === 'function') {
        const validationResult = await (slot as ValidatableInterface).validate(silent);
        validations.push(validationResult);
      }
    }

    const isValid = validations.reduce((result: boolean, entry: boolean) => {
      return result && entry;
    }, true);

    this.valid = isValid;
    return isValid;
  }
}
